import { Session } from '../microservices';
import { getBaseUrl } from '../../maps/apiEnvironmentMap';

const MODEL_TYPE: string = 'Installation';
export class SessionRequestPOST {
  readonly method: string = 'sessions';
  public buildURL() {
    let baseURL = getBaseUrl('security');
    return `${baseURL}/${this.method}`;
  }
  public generateContent(installation_id: string) {
    const params = new URLSearchParams();
    params.append('installation_id', installation_id);
    params.append('model_type', MODEL_TYPE);
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
}
export interface SessionResponsePOST {
  status: string;
  message: string;
  data: {
    errors: any;
    session: Session;
    message: string;
  };
}
